var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#E6EBF4"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1884 49.0948L21.9589 41.3244C22.1402 41.143 22.1402 40.849 21.9589 40.6677L19.3322 38.0411C19.1509 37.8598 18.8569 37.8598 18.6756 38.0411L10.9052 45.8115C10.7238 45.9929 10.7238 46.2869 10.9052 46.4682L13.5318 49.0948C13.7132 49.2761 14.0071 49.2761 14.1884 49.0948Z",
    fill: "#82A6E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3324 38.0411L20.974 39.6827C20.7927 39.5014 20.4986 39.5014 20.3174 39.6827L12.5469 47.4531C12.3656 47.6345 12.3656 47.9285 12.5469 48.1098L10.9053 46.4682C10.724 46.2868 10.724 45.9929 10.9053 45.8115L18.6758 38.0411C18.8571 37.8598 19.1511 37.8598 19.3324 38.0411Z",
    fill: "#2E6BCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0502 36.5973L23.4088 34.9559L19.8312 38.5335L21.4726 40.1749L25.0502 36.5973Z",
    fill: "#4380A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5151 42.7744L17.2324 39.4916L15.591 41.1329L18.8738 44.4157L20.5151 42.7744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8739 41.1331L17.2325 39.4917L15.5912 41.1331L17.2325 42.7744L18.8739 41.1331Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1403 40.9503C25.8061 40.9503 19.0498 34.194 19.0498 25.8597C19.0498 17.5255 25.8061 10.7692 34.1403 10.7692C42.4746 10.7692 49.2308 17.5255 49.2308 25.8597C49.2308 34.194 42.4746 40.9503 34.1403 40.9503Z",
    fill: "#43809F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1401 10.7692C34.5307 10.7692 34.9179 10.7841 35.301 10.8132C27.5091 11.406 21.3712 17.9161 21.3712 25.8598C21.3712 33.8036 27.5091 40.3136 35.301 40.9064C34.9179 40.9355 34.5308 40.9504 34.1401 40.9504C25.8059 40.9504 19.0496 34.1942 19.0496 25.8599C19.0496 17.5256 25.8059 10.7692 34.1401 10.7692V10.7692Z",
    fill: "#3A7190"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1405 38.6287C27.0884 38.6287 21.3715 32.9118 21.3715 25.8598C21.3715 18.8077 27.0884 13.0908 34.1405 13.0908C41.1925 13.0908 46.9094 18.8077 46.9094 25.8598C46.9094 32.9118 41.1925 38.6287 34.1405 38.6287Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1401 13.0908C34.5315 13.0908 34.9185 13.1095 35.301 13.1442C28.8022 13.7326 23.6929 19.2103 23.6929 25.8598C23.6929 32.5092 28.8022 37.9869 35.301 38.5753C34.9185 38.61 34.5315 38.6287 34.1401 38.6287C27.0993 38.6287 21.3712 32.9005 21.3712 25.8598C21.3712 18.819 27.0993 13.0908 34.1401 13.0908V13.0908Z",
    fill: "#E4E4E4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.4615,
    height: 38.4615,
    fill: "white",
    transform: "matrix(-1 0 0 1 49.2308 10.7692)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.2f07a792.svg";
export { ForwardRef as ReactComponent };